<template>
    <div style="height: 700px;overflow-y: auto;" class="box">
        <div style="width: 100%;text-align: center;background">
            <div><img id="bground" style="display:block;margin: 0 auto;" src="../../assets/images/distributor/dis01.png" /></div>
            <div><img id="bground" style="display:block;margin: 0 auto;" src="../../assets/images/distributor/dis02.png" /></div>
            <div style="position: relative;"><img id="bground" style="display:block;margin: 0 auto;" src="../../assets/images/distributor/dis03.png" /><span class="box_txt">
                    <h2><span @click="open">分销商操作指引</span></h2>
                </span></div>
            <div style="position: relative;"></div>
        </div>
        <div style="height: 140px;">
            <h1>盘活资源，实现躺赚</h1>
            <div style="margin-top:10px;color:red;">将以手机号码:{{sta.mobileNum===''?'':sta.mobileNum.replace(sta.mobileNum.substring(3,7),'****')}}绑定分销商</div>
            <div class="bodiv"> <Button :disabled="isBind" long size="large" type="warning" @click="showDialog2">{{isBind?'已绑定':'确认绑定'}}</Button></div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import store from '../../store/'
import ConstJson from "../../api/common/constjson.js"
let constJ = new ConstJson()
export default {
    name: 'binddistributor',
    // props:{
    //     modelType: {
    //         type: Number,
    //         default: 0,
    //     },
    // },
    data() {
        return {
            isBind:false,
        }
    },
    computed: {
        ...mapGetters(['sta'])
    },
    created() {

    },
    methods: {
        open(){
            window.open("https://mp.weixin.qq.com/s/paqP45WMpQ9FDI3OJq55PQ","_blank")
        },
        showDialog2() {
            if(this.isBind){return}
            let that = this
            this.$Modal.confirm({
                title: "确认绑定分销商",
                //content: '<p>' + content + '</p>',
                render: h => {
                    return h('span', [
                        '若您未注册分销商账号，本流程将自动为您注册分销商并关联云擎账号， ',
                        h('span', {
                            domProps: {
                                innerHTML: `<span style="color:#ff9900;font-size:14px;" >确认绑定吗 </span>`,
                            }
                        }), '  ?'
                    ])
                },
                okText: '确认',
                cancelText: '取消',
                onOk: () => {
                    //逻辑处理
                    //二次确认，点击确定时有关闭窗体的冒泡，需要延时弹出子窗体
                    setTimeout(() => {
                        this.bind()
                    }, 500)

                },
                onCancel: () => {
                    return
                    // this.$Message.info('Clicked cancel');
                }
            });
        },
        bind() {
            console.log('bind-distributor==>')
            constJ.bindDistributor().then(res => {
                console.log(res)
                if (res.rtncode == 1) {
                    if (res.rltcode == 1) {
                        //this.$Message.success('绑定分销商成功。');
                        this.isBind=true
                        this.$Modal.success({
                            title: '提示',
                            content: '绑定分销商成功。',
                            onOk: () => {
                                //this.$emit('close')
                                return
                            }
                        });

                    } else {
                        this.$Modal.warning({
                            title: '提示',
                            content: res.rltdesc,
                            onOk: () => {
                                //this.$emit('close')
                                return
                            }
                        });
                    }
                }
            })
        }

    }
}
</script>
<style lang="less" scoped>
.box {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.box_txt {
    text-decoration: underline;
    color: white;
    cursor: pointer;
    display: flex;
    position: absolute;
    height: 100px;
    bottom: -2px;
    //background:gray;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.bodiv {
    margin-top: 10px;
    width: 25%;
    margin: 0 auto;
    margin-top: 10px;
}
</style>